// Slab lot seçimi, foto görüntüleyici ve teklif çubuğu.
// Seçim sayfa yenilense de kalsın diye sessionStorage'da (ürün bazında) tutulur.
// Her değişiklikte 'slab-lots:change' olayı yayılır; teklif penceresi bunu dinler.
class SlabLots extends HTMLElement {
  connectedCallback() {
    this.key = 'slab-lots:' + location.pathname;
    this.cards = [...this.querySelectorAll('.sl-card')];
    this.tray = this.querySelector('[data-sl-tray]');
    this.summary = this.querySelector('[data-sl-summary]');
    this.dialog = this.querySelector('[data-sl-dialog]');
    try { this.data = JSON.parse(this.querySelector('[data-sl-data]').textContent); } catch { this.data = []; }
    let saved = [];
    try { saved = JSON.parse(sessionStorage.getItem(this.key) || '[]'); } catch {}
    this.cards.forEach((card) => {
      const btn = card.querySelector('[data-sl-pick]');
      if (!btn) return;
      if (saved.includes(card.dataset.lot)) this.toggle(card, true, false);
      btn.addEventListener('click', () => this.toggle(card, btn.getAttribute('aria-pressed') !== 'true'));
    });
    this.querySelector('[data-sl-clear]')?.addEventListener('click', () => {
      this.cards.forEach((c) => c.querySelector('[data-sl-pick]') && this.toggle(c, false, false));
      this.sync();
    });
    this.querySelectorAll('[data-sl-view]').forEach((b) => b.addEventListener('click', () => this.view(+b.dataset.slView)));
    this.querySelector('[data-sl-close]')?.addEventListener('click', () => this.dialog.close());
    this.dialog?.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
    document.addEventListener('slab-lots:remove', (e) => {
      const card = this.cards.find((c) => c.dataset.lot === e.detail);
      if (card) this.toggle(card, false);
    });
    this.sync();
  }

  toggle(card, on, sync = true) {
    card.classList.toggle('is-picked', on);
    card.querySelector('[data-sl-pick]').setAttribute('aria-pressed', String(on));
    if (sync) this.sync();
  }

  selected() {
    return this.cards.filter((c) => c.classList.contains('is-picked')).map((c) => ({
      id: c.dataset.lot, slabs: +c.dataset.slabs || 0, sqft: +c.dataset.sqft || 0, size: c.dataset.size,
    }));
  }

  sync() {
    const list = this.selected();
    try { sessionStorage.setItem(this.key, JSON.stringify(list.map((l) => l.id))); } catch {}
    const slabs = list.reduce((n, l) => n + l.slabs, 0);
    const sqft = Math.round(list.reduce((n, l) => n + l.sqft, 0));
    this.tray.hidden = list.length === 0;
    this.summary.textContent = this.summary.dataset.tpl
      .replace('__l__', list.length).replace('__s__', slabs).replace('__a__', sqft.toLocaleString('en-US'));
    document.dispatchEvent(new CustomEvent('slab-lots:change', { detail: { lots: list, slabs, sqft } }));
  }

  view(i) {
    const lot = this.data[i];
    if (!lot || !this.dialog) return;
    this.dialog.querySelector('[data-sl-dialog-title]').textContent = 'Lot ' + lot.id;
    const track = this.dialog.querySelector('[data-sl-track]');
    track.replaceChildren(...lot.photos.map((p) => {
      const fig = document.createElement('figure');
      fig.className = 'sl-view__item';
      const img = document.createElement('img');
      img.loading = 'lazy';
      img.src = p.src + '&width=1600';
      img.alt = (p.no ? 'Slab ' + p.no + ', lot ' : 'Lot ') + lot.id;
      const cap = document.createElement('figcaption');
      // Numarasız (bundle) fotoğrafta tipik ölçü yazılır.
      cap.textContent = (p.no ? 'Slab ' + p.no : 'Typical slab') + ' · ' + p.size_in + ' in (' + p.size_cm + ' cm)' + (p.no ? ' · ' + p.sqft + ' sq ft' : '');
      fig.append(img, cap);
      return fig;
    }));
    this.dialog.showModal();
    track.scrollLeft = 0;
  }
}
if (!customElements.get('slab-lots')) customElements.define('slab-lots', SlabLots);
